import AppListing from '../app-components/Listing/AppListing';

Vue.component('financial-balance-listing', {
    mixins: [AppListing]
});